import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { RestService } from './rest.service';
import { IUserRole } from '../../../shared/interfaces/user-role.interface';

@Injectable({
  providedIn: 'root',
})
export class UserRoleService {
  private userRoles$: Observable<IUserRole[]> | null = null;

  constructor(private restService: RestService) {}

  /** User roles are global and rarely change, so they are fetched once per page load; a failed fetch is retried next time. */
  public getUserRoles(): Observable<IUserRole[]> {
    this.userRoles$ ??= this.restService.getUserRoles().pipe(
      catchError((error: unknown): Observable<never> => {
        this.userRoles$ = null;
        throw error;
      }),
      shareReplay(1),
    );

    return this.userRoles$;
  }
}
